<template>
	<div>
		<transition appear :mode="'out-in'" :name="transitionName">
			<slot />
		</transition>
		<slot name="bottom-content"> </slot>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const transitionName = computed((): string => {
	if (appStore.routeTransition.scope === 'subpage') {
		return `transition--${appStore.routeTransition.name}`;
	} else {
		return 'none';
	}
});
</script>
<style lang="scss">
.transition-all {
	transition: 0.5s all ease;
}

.transition-crossfade.enter-from {
	animation: crossfade-in;
	animation-duration: 0.5s;
}

.transition-crossfade.leave-to {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	animation: crossfade-out;
	animation-duration: 0.5s;
}

@keyframes crossfade-in {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@keyframes crossfade-out {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 0;
	}
}

.fade {
	opacity: 0;
	transition: 0.3s opacity ease;
}

.fade.in {
	opacity: 1;
}

.collapse {
	display: none;
	opacity: 0;

	&.in {
		display: block;
		opacity: 1;
	}
}

.collapsing {
	position: relative;
	height: 0;
	overflow: hidden;
	transition: 0.35s all ease;
}
</style>
